import React, { useEffect } from "react";
import Pagination from "./pagination";
import TitleHeader from "./title";
import CardTotalEditable from "./cardTotalEditable";
import CardTotal from "./cardTotal";
import CustomerOrSupplier from "./customerOrSupplier";
import MovementForm from "./movementForm";
import { getActivities } from "../../../../store/actions/precog";
import { useDispatch } from "react-redux";
import "./style.css";

const InfoHeader = ({
  changeDetail, createReason, currentDetailIndex, currentParams, formByReason, 
  invoicesLength, isCreate, isFirstDetail, isLastDetail, newDetail, reasonsBankActive, 
  sectionalError, setSectionalError, setLastUpdate, einvoiceType,
  setModifiedDetail, setNewDetail, setReason, setReloadModal, totalTax, totalTaxable, setPreviewModal
}) => {    
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(getActivities()).then(el => el).catch(function(error) {
      console.log(error);
    });
  }, []);

  return (    
    <div className="pre-cog-detail-header-document-title" style={{padding: "24px 0", flexDirection: "column"}}>
      <div style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between"}}>        
        <div style={{flexGrow:1, paddingLeft: "48px"}}>
          <TitleHeader currentParams={currentParams} isCreate={isCreate} 
            newDetail={newDetail} 
            setModifiedDetail={setModifiedDetail} 
            setNewDetail={setNewDetail}
            setPreviewModal={setPreviewModal} einvoiceType={einvoiceType} />
        </div>
        {/** pagination */}
        <div style={{paddingRight: "48px"}}>
          <Pagination 
            changeDetail={changeDetail}
            currentDetailIndex={currentDetailIndex} 
            invoicesLength={invoicesLength}
            isFirstDetail={isFirstDetail}
            isLastDetail={isLastDetail} />
        </div>
      </div>
      <div style={{display: "flex", width: "100%", gap: "24px", borderBottom: "1px solid var(--grey-01)", margin: "0, -48px", paddingBottom: "38px"}}>
        {formByReason?.customerOrSupplier &&
          <div>
            <CustomerOrSupplier formByReason={formByReason} newDetail={newDetail}
              setModifiedDetail={setModifiedDetail}
            />
          </div>
        }
        <div className="formDiv"> 
          <MovementForm
            reasonsBankActive={reasonsBankActive}
            createReason={createReason || newDetail.reasonId}
            setReason={setReason}
            newDetail={newDetail}
            setModifiedDetail={setModifiedDetail}
            setNewDetail={setNewDetail}
            formByReason={formByReason}
            sectionalError={sectionalError} 
            setSectionalError={setSectionalError}
            setLastUpdate={setLastUpdate}   
            setReloadModal={setReloadModal}                 
          /> 
                  
        </div>
        <div style={{paddingRight: "48px"}}>
          { // gestisco in defaultValue quindi controllo di avere i requisiti per mostrare la card in modifica            
            newDetail?.source === "MANUAL" || isCreate || newDetail.source === "DOC" ?
              (!newDetail?.id && !isCreate) ? null :
                <CardTotalEditable isTax={formByReason?.isTotalTax} newDetail={newDetail} isCreate={isCreate} 
                  amount={newDetail?.amount ? newDetail.amount : ""} setNewDetail={setNewDetail} totalTax={totalTax} totalTaxable={totalTaxable}/>
              :
              <CardTotal amount={newDetail?.amount ? newDetail.amount : ""} isTax={formByReason?.isTotalTax}  totalTax={totalTax} totalTaxable={totalTaxable} />
          }
        </div>

      </div>
    </div>
  );
};

export default InfoHeader;
